import script from "./defaultToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./defaultToolbar.vue?vue&type=script&setup=true&lang=ts"

import "./defaultToolbar.vue?vue&type=style&index=0&id=260271e0&lang=scss"

const __exports__ = script;

export default __exports__